import { StateCreator } from 'zustand';

import { INITIAL_PLATFORM_STATE, Platform, PlatformStore } from './types';

export const handleSetPlatform = (
  set: Parameters<StateCreator<PlatformStore>>[0],
  platform: Platform,
) => {
  set({ platformSelected: platform });
};

export const handleResetState = (
  set: Parameters<StateCreator<PlatformStore>>[0],
) => {
  set(INITIAL_PLATFORM_STATE);
};
